import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/config/content";
import { trackPageview } from "@/lib/analytics";

const PAGES = {
  impressum: {
    title: "Impressum",
    placeholder: false,
    sections: [
      {
        heading: "Angaben gemäß § 5 TMG",
        body: "JUSTIN HILFT\nJustin Mochkaai\nAm Vohbach 21\n86666 Burgheim",
      },
      {
        heading: "Kontakt",
        body: `Telefon: ${CONTACT.phoneDisplay}\nE-Mail: ${CONTACT.email}`,
      },
      {
        heading: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
        body: "Justin Mochkaai, Anschrift wie oben",
      },
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    placeholder: false,
    sections: [
      {
        heading: "1. Verantwortlicher",
        body: `Verantwortlich für die Datenverarbeitung auf dieser Website ist:\nJUSTIN HILFT, Justin Mochkaai, Am Vohbach 21, 86666 Burgheim, ${CONTACT.email}, Tel. ${CONTACT.phoneDisplay}`,
      },
      {
        heading: "2. Erhebung und Speicherung personenbezogener Daten",
        body: "Bei Nutzung des Kontaktformulars werden die von dir angegebenen Daten (Name, E-Mail, Telefonnummer, ggf. Adresse, Nachricht sowie optional hochgeladene Fotos) zur Bearbeitung deiner Anfrage gespeichert. Bei Aufträgen werden zusätzlich Vertrags- und Rechnungsdaten sowie deine digitale Unterschrift gespeichert. Eine Weitergabe an Dritte erfolgt nicht ohne deine Einwilligung — ausgenommen die unten genannten Dienstleister, die zur technischen Abwicklung erforderlich sind.",
      },
      {
        heading: "3. Eingesetzte Dienstleister (Auftragsverarbeitung)",
        body: "Zur technischen Umsetzung setzen wir folgende Dienste ein:\n• Hosting und Bereitstellung der Website: Emergent (Cloudflare-Infrastruktur)\n• E-Mail-Versand (Anfragen, Auftragsbestätigungen, Rechnungen): Resend\n• Online-Zahlungsabwicklung: Stripe (bei Zahlung werden die erforderlichen Daten an Stripe übermittelt)\n• Interne KI-Auswertung von Anfragen (Text und ggf. Fotos zur Aufwandseinschätzung, nur intern sichtbar): OpenAI\nDiese Dienstleister verarbeiten Daten in unserem Auftrag. Teilweise erfolgt eine Verarbeitung in den USA; dabei werden die jeweils geltenden Standardvertragsklauseln der Anbieter genutzt.",
      },
      {
        heading: "4. Cookies, Analytics und Partner-Links",
        body: "Diese Website verwendet technisch notwendige lokale Speicherung (z. B. für den Cookie-Hinweis). Zusätzlich setzen wir eine datenschutzfreundliche, eigene Besucherstatistik ein (Server-seitig, ohne Werbenetzwerke):\n• Ohne deine Einwilligung: Es werden ausschließlich anonyme Tages-Statistiken erfasst (aufgerufene Seiten, Klicks auf Schaltflächen, Gerätetyp). Deine IP-Adresse wird nicht gespeichert — sie fließt nur in einen nicht umkehrbaren, täglich wechselnden Hash-Wert ein, um Besucher desselben Tages zu zählen. Ein Wiedererkennen über Tage hinweg ist damit nicht möglich.\n• Nur mit deiner Einwilligung („Alle akzeptieren“): Zusätzlich wird eine zufällige, anonyme Besucher-ID lokal in deinem Browser gespeichert, damit wir wiederkehrende Besucher erkennen können. Diese ID enthält keine persönlichen Daten und kann von dir jederzeit im Browser gelöscht werden.\n• Partner-Links: Links zu unserem Partner Rent500 laufen über eine Zähl-Weiterleitung, bei der der Klick (Zeitpunkt, Gerätetyp) erfasst wird. Beim Weiterleiten werden sogenannte UTM-Parameter übergeben, damit Rent500 erkennen kann, dass du über unsere Website kommst. Es werden keine Daten an Werbenetzwerke verkauft oder weitergegeben.\nBeim Laden der Seiten werden Schriftarten von Google Fonts und Fontshare geladen; dabei wird deine IP-Adresse an die jeweiligen Anbieter übermittelt.",
      },
      {
        heading: "5. Speicherdauer und Löschung",
        body: "Anfragen und Auftragsdaten werden nur so lange gespeichert, wie es für die Abwicklung und gesetzliche Aufbewahrungspflichten erforderlich ist. Du kannst jederzeit die Löschung deiner Daten (inklusive hochgeladener Fotos) per E-Mail anfordern.",
      },
      {
        heading: "6. Deine Rechte",
        body: "Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner personenbezogenen Daten sowie ein Beschwerderecht bei der zuständigen Aufsichtsbehörde. Wende dich dazu einfach an die oben genannte E-Mail-Adresse.",
      },
      {
        heading: "Hinweis",
        body: "Diese Datenschutzerklärung wurde nach bestem Wissen für das tatsächlich eingesetzte System erstellt. Sie ersetzt keine anwaltliche Beratung — für verbindliche rechtliche Sicherheit wird eine Prüfung durch einen Fachanwalt empfohlen.",
      },
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    placeholder: false,
    sections: [
      {
        heading: "1. Geltungsbereich",
        body: "Diese Allgemeinen Geschäftsbedingungen gelten für alle Dienstleistungen von JUSTIN HILFT, Justin Mochkaai, Am Vohbach 21, 86666 Burgheim (nachfolgend „Dienstleister“), gegenüber Verbrauchern.",
      },
      {
        heading: "2. Vertragsschluss",
        body: "Anfragen über die Website, per E-Mail, Telefon oder WhatsApp sind unverbindlich. Ein Vertrag kommt erst durch individuelle Absprache und Bestätigung des Auftrags durch den Dienstleister zustande.",
      },
      {
        heading: "3. Leistungen",
        body: "Der Umfang der jeweiligen Dienstleistung (z. B. Gartenservice, Hausmeisterservice, Umzugshilfe, Entrümpelung, Tierbetreuung, Clothing & Design, Autosuche) wird individuell mit dem Kunden vereinbart. Der Dienstleister stellt vorrangig seine Arbeitskraft zur Verfügung. Benötigte Geräte, Maschinen, Werkzeuge, Fahrzeuge oder Materialien werden vom Kunden bereitgestellt, sofern nicht ausdrücklich etwas anderes vereinbart wurde.",
      },
      {
        heading: "4. Mitwirkung des Kunden",
        body: "Der Kunde stellt sicher, dass bereitgestellte Geräte und Fahrzeuge funktionstüchtig und einsatzbereit sind und dass der Dienstleister Zugang zum Einsatzort sowie erforderlichenfalls Strom und Wasser hat.",
      },
      {
        heading: "5. Preise und Zahlung",
        body: "Es gilt der bei der Buchung bzw. im Angebot genannte Preis. Festpreis-Leistungen (Tierbetreuung, Clothing & Design, Clothing Brand Aufbau, Autosuche) werden direkt online bezahlt. Bei individuellen Angeboten (z. B. Gartenservice, Hausmeisterservice, Entrümpelung) wird der Preis vor Auftragsbeginn mitgeteilt. Rechnungsbeträge sind am Tag der Rechnungsstellung ohne Abzug fällig; aus Kulanz kann im Einzelfall eine Zahlungsfrist von maximal 7 Tagen vereinbart werden.",
      },
      {
        heading: "6. Termine und Stornierung",
        body: "Gebuchte und bestätigte Termine sind verbindlich. Eine kostenfreie Stornierung ist nicht möglich. Kannst du einen gebuchten Termin nicht wahrnehmen oder sagst ihn ab — gleich aus welchem Grund und zu welchem Zeitpunkt — werden 50 % der vereinbarten Vergütung als Ausfallpauschale fällig; bereits bezahlte Beträge werden entsprechend verrechnet. Eine Terminverschiebung ist nur nach vorheriger Absprache und je nach Verfügbarkeit möglich.",
      },
      {
        heading: "7. Widerruf",
        body: "Ein Widerrufsrecht besteht nicht. Es handelt sich um Dienstleistungen zu einem fest vereinbarten Termin bzw. Zeitpunkt (§ 312g Abs. 2 Nr. 9 BGB). Mit der Buchung und Zahlung beauftragst du ausdrücklich die verbindliche Leistungserbringung zum vereinbarten Termin. Buchungen sind daher endgültig; es gilt die Regelung zu Ausfällen unter Punkt 6.",
      },
      {
        heading: "8. Haftung",
        body: "Der Dienstleister haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit. Bei leichter Fahrlässigkeit haftet er nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Für Schäden, die durch vom Kunden bereitgestellte Geräte, Fahrzeuge oder Materialien entstehen, wird keine Haftung übernommen, soweit gesetzlich zulässig.",
      },
      {
        heading: "9. Website-Pakete und monatlicher Betrieb",
        body: "Beim Kauf eines Website-Pakets (STANDARD, PLUS, PREMIUM) ist der Paketpreis einmalig bei Bestellung fällig. Zusätzlich gilt eine verpflichtende monatliche Betriebsgebühr von 10 €, die ausschließlich die laufenden Betriebskosten (Hosting und technischer Betrieb über die genutzte Plattform) deckt und keine Gewinnmarge enthält. Die Betriebsgebühr wird erstmals am Tag der Fertigstellung bzw. Veröffentlichung der Website fällig und danach monatlich automatisch über das bei der Bestellung hinterlegte Zahlungsmittel abgebucht; der Kunde stimmt dieser Abbuchung bei der Bestellung ausdrücklich zu.\n\nOptional kann ein monatliches Support-Abo abgeschlossen werden: SUPPORT BASIC (39 €/Monat: Überwachung und Fehlerbehebung, keine inhaltlichen Änderungen) oder SUPPORT PREMIUM (59 €/Monat: zusätzlich 2 individuelle Änderungen pro Monat). Nicht genutzte Änderungs-Credits verfallen am Monatsende und werden nicht übertragen. Zusätzliche Änderungen über die Credits hinaus sind gesondert zu vergüten.\n\nDas Abo (Betrieb und ggf. Support) läuft auf unbestimmte Zeit. Eine Kündigung durch den Kunden ist aus wichtigem Grund möglich, insbesondere wenn die Website dauerhaft nicht erreichbar ist oder der Dienstleister seine Leistungen trotz Abmahnung nicht erbringt. Die Verwaltung und Kündigung des Abos erfolgt über den Dienstleister. Nach Kündigung des Betriebsabos kann die Website nicht weiter über das System des Dienstleisters betrieben werden.",
      },
      {
        heading: "10. Schlussbestimmungen",
        body: "Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.\n\nHinweis: Diese AGB sind ein sorgfältig erstellter Standard-Entwurf, ersetzen aber keine anwaltliche Prüfung im Einzelfall.",
      },
    ],
  },
};

export default function LegalPage({ page }) {
  const content = PAGES[page] || PAGES.impressum;

  useEffect(() => {
    trackPageview(`/${page}`);
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    document.title = `${content.title} | JUSTIN HILFT`;
    meta?.setAttribute(
      "content",
      `${content.title} von JUSTIN HILFT, Justin Mochkaai, Am Vohbach 21, 86666 Burgheim.`
    );
    return () => {
      document.title = prevTitle;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content.title]);

  return (
    <main data-testid={`legal-page-${page}`} className="min-h-screen bg-paper text-ink px-6 lg:px-12 py-16">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-ink transition-colors duration-300 mb-16"
        >
          <ArrowLeft size={14} /> Zurück zur Startseite
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-display font-bold uppercase tracking-tight text-lg mb-2">
            Justin Hilft<span className="text-gold">.</span>
          </p>
          <h1 className="font-display uppercase tracking-tight text-4xl sm:text-5xl mb-6">
            {content.title}
          </h1>
          {content.placeholder && (
            <p
              data-testid="legal-placeholder-note"
              className="border border-gold/40 bg-gold/5 text-sm text-zinc-600 px-4 py-3 mb-14"
            >
              Hinweis: Dies ist ein Platzhalter. Bitte ersetze die Inhalte durch
              deine echten Angaben, bevor die Seite live geht.
            </p>
          )}

          <div className="space-y-12">
            {content.sections.map((s) => (
              <section key={s.heading}>
                <h2 className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
                  {s.heading}
                </h2>
                <p className="text-base leading-relaxed text-zinc-600 whitespace-pre-line">
                  {s.body}
                </p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </main>
  );
}
